import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { SharedModule } from '@modules/shared.module';
import { ButtonCancelComponent } from '../button-cancel/button-cancel.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogClose } from '@angular/material/dialog';

type LoadingAnimation = 'spin' | 'pulse' | 'bounce';

@Component({
  selector: 'app-button-add',
  standalone: true,
  imports: [MatIconModule, MatButtonModule],
  template: `
    <div class="button-container">
      <button
        mat-raised-button
        color="primary"
        [disabled]="disabled || loading"
        name="Agregar"
        (click)="onButtonClick()">
        <mat-icon>
          {{ loading ? loadingIcon : 'add' }}
        </mat-icon>
        {{ loading ? loadingText : buttonText }}
      </button>
    </div>
  `,
  styleUrls: ['./button-add.component.css'],
})
export class ButtonAddComponent {
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() isDialogClose: boolean = false;
  @Input() buttonText: string = 'Agregar';
  @Input() loadingText: string = 'Agregando...';
  @Input() loadingIcon: string = 'refresh';
  @Input() loadingAnimation: LoadingAnimation = 'spin';

  @Output() click = new EventEmitter<void>();

  constructor() {
    if (this.isDialogClose)
      this.isDialogClose = !this.isDialogClose;
  }

  onButtonClick(): void {
    if (!this.disabled && !this.loading) {
      this.click.emit();
    }
  }

  getIconClass(): string {
    if (!this.loading) return '';

    switch (this.loadingAnimation) {
      case 'spin':
        return 'loading-spin';
      case 'pulse':
        return 'loading-pulse';
      case 'bounce':
        return 'loading-bounce';
      default:
        return 'loading-spin';
    }
  }
}
